module.exports = __webpack_public_path__ + "img/classic.231d1d0a.gif";